import { createRoute } from '@tanstack/react-router';

import OrgWorkspaceLayout from '@web/core/org_workspace_layout';
import { OverviewPage } from '@web/ui/overview';

import { orgRoute } from './org_routes';

export const orgWorkspaceLayoutRoute = createRoute({
  getParentRoute: () => orgRoute,
  id: 'org-workspace',
  component: OrgWorkspaceLayout,
});

/**
 * `/orgs/$orgSlug/overview` — landing route after login. Renders the
 * agent task overview (Visão Geral) — title eyebrow, summary line and
 * grouped task sections. Live data wires up once the backend ships the
 * per-agent overview feed.
 */
export const overviewIndexRoute = createRoute({
  getParentRoute: () => orgWorkspaceLayoutRoute,
  path: 'overview',
  component: OverviewPage,
});
